import { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";

// Servizio gratuito di inoltro email (nessun backend, nessun costo)
const ENDPOINT = "https://formsubmit.co/ajax/asi.sicilia.onlus@gmail.com";

const initial = { nome: "", email: "", telefono: "", oggetto: "", messaggio: "", _honey: "" };

const ContactForm = () => {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form._honey) return; // anti-spam: bot honeypot
    if (form.nome.trim().length < 2) return toast.error("Inserisci il tuo nome.");
    if (form.messaggio.trim().length < 5) return toast.error("Scrivi un messaggio più completo.");
    setLoading(true);
    try {
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          Nome: form.nome,
          Email: form.email,
          Telefono: form.telefono || "—",
          Oggetto: form.oggetto,
          Messaggio: form.messaggio,
          _subject: `Nuovo messaggio dal sito ASI Sicilia: ${form.oggetto}`,
          _template: "table",
          _captcha: "false",
        }),
      });
      const data = await res.json();
      if (res.ok && (data.success === "true" || data.success === true)) {
        toast.success("Messaggio inviato! Ti risponderemo al più presto.");
        setForm(initial);
      } else {
        toast.error("Invio non riuscito. Riprova o scrivici via email.");
      }
    } catch (err) {
      toast.error("Invio non riuscito. Controlla la connessione e riprova.");
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full rounded-xl border border-stone-300 bg-white px-4 py-3 text-stone-900 placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-lime-900/30 focus:border-lime-900 transition";

  return (
    <form data-testid="contact-form" onSubmit={onSubmit} className="space-y-4">
      <input
        type="text"
        name="_honey"
        value={form._honey}
        onChange={onChange}
        className="hidden"
        tabIndex="-1"
        autoComplete="off"
      />

      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-stone-700 mb-1.5">Nome e cognome</label>
          <input data-testid="contact-input-nome" name="nome" required value={form.nome} onChange={onChange} placeholder="Mario Rossi" className={field} />
        </div>
        <div>
          <label className="block text-sm font-medium text-stone-700 mb-1.5">Email</label>
          <input data-testid="contact-input-email" type="email" name="email" required value={form.email} onChange={onChange} placeholder="nome@email.it" className={field} />
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-stone-700 mb-1.5">Telefono (opzionale)</label>
          <input data-testid="contact-input-telefono" name="telefono" value={form.telefono} onChange={onChange} placeholder="3xx xxx xxxx" className={field} />
        </div>
        <div>
          <label className="block text-sm font-medium text-stone-700 mb-1.5">Oggetto</label>
          <input data-testid="contact-input-oggetto" name="oggetto" required value={form.oggetto} onChange={onChange} placeholder="Richiesta informazioni" className={field} />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-stone-700 mb-1.5">Messaggio</label>
        <textarea data-testid="contact-input-messaggio" name="messaggio" required rows={5} value={form.messaggio} onChange={onChange} placeholder="Scrivi qui il tuo messaggio..." className={`${field} resize-none`} />
      </div>

      <button
        data-testid="contact-submit-button"
        type="submit"
        disabled={loading}
        className="inline-flex items-center justify-center gap-2 rounded-full bg-lime-900 text-lime-50 px-7 py-3.5 font-medium hover:bg-lime-800 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
        {loading ? "Invio in corso..." : "Invia messaggio"}
      </button>
    </form>
  );
};

export default ContactForm;
